/**
 * Shared date-range helpers for period-filtered content views.
 * Both the client portal (light) and internal Posts board (dark) use these.
 */

export function periodRange(period, anchor) {
  const d = new Date(anchor);
  d.setHours(0, 0, 0, 0);
  if (period === "day") {
    const end = new Date(d); end.setHours(23, 59, 59, 999);
    return [d, end];
  }
  if (period === "month") {
    const start = new Date(d.getFullYear(), d.getMonth(), 1);
    const end = new Date(d.getFullYear(), d.getMonth() + 1, 0, 23, 59, 59, 999);
    return [start, end];
  }
  // ISO week — Monday start
  const dow = d.getDay();
  const backToMon = (dow + 6) % 7;
  const start = new Date(d); start.setDate(d.getDate() - backToMon);
  const end = new Date(start); end.setDate(start.getDate() + 6); end.setHours(23, 59, 59, 999);
  return [start, end];
}

export function shiftAnchor(period, anchor, dir) {
  const d = new Date(anchor);
  if (period === "day") d.setDate(d.getDate() + dir);
  else if (period === "week") d.setDate(d.getDate() + 7 * dir);
  else d.setMonth(d.getMonth() + dir);
  return d;
}

export function labelRange(period, start, end) {
  const short = { month: "short", day: "numeric" };
  if (period === "day") {
    return start.toLocaleDateString(undefined, { weekday: "long", month: "short", day: "numeric" });
  }
  if (period === "month") {
    return start.toLocaleDateString(undefined, { month: "long", year: "numeric" });
  }
  const sameMonth = start.getMonth() === end.getMonth();
  const left = start.toLocaleDateString(undefined, short);
  const right = sameMonth ? end.getDate() : end.toLocaleDateString(undefined, short);
  return `${left} – ${right}`;
}

/** Best date on a post for range filtering — scheduled > published > created. */
export function postDateOf(p) {
  const s = p.due_date || p.published_at || p.created_at;
  return s ? new Date(s) : null;
}

export function isSameDay(a, b) {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}
